import React, { useMemo } from 'react';
import COPY from '../../data/featurePromoCopy.json';
import { chartHref } from '../../data/chartLanguage';
import './FeaturePromo.css';

const DAILY = { id: 'dailyHoroscope', to: '/personalized-daily-horoscope/', glyph: '☀︎', featured: true };
const CHART_LINKS = new Set(['birthChart', 'chartCompatibility', 'dailyHoroscope']);

const NEW_FEATURES = [
  { id: 'birthChart', to: '/birth-chart/', glyph: '☉' },
  { id: 'zodiacCompatibility', to: '/zodiac-compatibility/', glyph: '♥' },
  { id: 'chartCompatibility', to: '/birth-chart-compatibility/', glyph: '⚭' },
  { id: 'moonPhase', to: '/moon-phase-today/', glyph: '☾' },
  { id: 'lifePath', to: '/life-path-number-calculator/', glyph: '7' },
  { id: 'birthCard', to: '/tarot-birth-card-calculator/', glyph: '✦' },
];

const CLASSIC_FEATURES = [
  { id: 'yesNo', to: '/yes-or-no-tarot/', glyph: '?' },
  { id: 'love', to: '/love-tarot-reading/', glyph: '♡' },
  { id: 'celticCross', to: '/celtic-cross-tarot/', glyph: '✚' },
  { id: 'cardOfTheDay', to: '/card-of-the-day/', glyph: '☀' },
  { id: 'venus', to: '/venus-sign-calculator/', glyph: '♀' },
];

function pick(list, count) {
  const copy = [...list];
  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy.slice(0, count);
}

function rotate(list, seed, count, exclude) {
  const options = list.filter((item) => item.to !== exclude);
  let hash = 0;
  for (const char of seed) hash = (hash * 31 + char.charCodeAt(0)) % 9973;
  return Array.from({ length: Math.min(count, options.length) }, (_, i) => options[(hash + i) % options.length]);
}

const FeaturePromo = ({ variant = 'home', lang = 'en', seed = '', exclude = '' }) => {
  const copy = COPY[lang] || COPY.en;
  const items = useMemo(() => {
    const lead = exclude === DAILY.to ? [] : [DAILY];
    if (variant === 'home') return [...lead, ...NEW_FEATURES];
    if (variant === 'page') {
      return [...lead, ...rotate(NEW_FEATURES, seed, 3 - lead.length, exclude), ...rotate(CLASSIC_FEATURES, seed, 3, exclude)];
    }
    return [...lead, ...pick(NEW_FEATURES, 2 - lead.length), ...pick(CLASSIC_FEATURES, 2)];
  }, [variant, seed, exclude]);
  const home = variant === 'home';

  return (
    <section
      className={`feature-promo feature-promo-${variant}`}
      aria-labelledby={`feature-promo-${variant}`}
      lang={lang}
      dir={lang === 'ar' ? 'rtl' : undefined}
    >
      <p className="feature-promo-eyebrow">{home ? copy.homeEyebrow : copy.modalEyebrow}</p>
      <h2 id={`feature-promo-${variant}`} className="feature-promo-title">
        {home ? copy.homeTitle : copy.modalTitle}
      </h2>
      <ul className="feature-promo-grid">
        {items.map((item) => (
          <li key={item.id}>
            <a
              className={`feature-promo-card${item.featured ? ' feature-promo-featured' : ''}`}
              href={CHART_LINKS.has(item.id) ? chartHref(item.to, lang) : item.to}
            >
              <span className="feature-promo-glyph" aria-hidden="true">{item.glyph}</span>
              <span className="feature-promo-text">
                <strong>{copy.items[item.id].title}</strong>
                <span>{copy.items[item.id].text}</span>
              </span>
            </a>
          </li>
        ))}
      </ul>
      {lang !== 'en' && copy.englishNote && <p className="feature-promo-note">{copy.englishNote}</p>}
    </section>
  );
};

export default FeaturePromo;
